import React, { useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
  Alert,
} from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GroupedPermissionSelector from "./GroupedPermissionSelector"

const RoleFormAdd = ({ onSubmit, loading, error, groupedPermissions }) => {
  const [selectedPermissions, setSelectedPermissions] = useState([])

  const validation = useFormik({
    initialValues: {
      name: "",
      permissions: [],
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Role name is required")
        .min(2, "Role name must be at least 2 characters"),
    }),
    onSubmit: values => {
      const formData = {
        ...values,
        permissions: selectedPermissions,
      }
      onSubmit(formData)
    },
  })

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title="Add Role"
          lgColumn={2}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={true}
          rightBtnTitle="Back"
          rightBtnRoute="/roles"
        />

        {error && <Alert color="danger">{error}</Alert>}

        <Form onSubmit={validation.handleSubmit} className="mt-4">
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="name">Role Name *</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter role name"
                  value={validation.values.name}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.name && validation.errors.name
                      ? true
                      : false
                  }
                />
                {validation.touched.name && validation.errors.name && (
                  <FormFeedback>{validation.errors.name}</FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={12}>
              <h5 className="mb-3">Assign Permissions</h5>
              <GroupedPermissionSelector
                groupedPermissions={groupedPermissions}
                selectedPermissions={selectedPermissions}
                onChange={setSelectedPermissions}
              />
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <div className="text-end">
                <Button
                  type="button"
                  color="secondary"
                  className="me-2"
                  onClick={() => window.history.back()}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={loading}>
                  {loading ? "Creating..." : "Create Role"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default RoleFormAdd
